import { FC } from "react";

import { StyledDivider } from "./styles";
import { DividerProps } from "./types";

export const DashboardDivider: FC<DividerProps> = ({ vibe, ...restOfProps }) => {
  return <StyledDivider {...restOfProps} style={{ borderColor: vibe }} />;
};
